// This file is for logging non-fatal errors to the console
// and to sentry when appropriate
import * as Sentry from '@sentry/react';
import env from './env';

const logError = (message, extras = {}) => {
  if (['int', 'prod', 'staging'].includes(env.name)) {
    Sentry.withScope(scope => {
      Object.keys(extras).forEach(key => {
        scope.setExtra(key, extras[key]);
      });
      Sentry.captureException(Error(message));
    });
  }
};

/**
 * Async version of logError that waits for the error to be sent to Sentry
 * Use this when you need to ensure logging completes before proceeding (e.g., before redirects)
 * @param {string} message - Error message
 * @param {object} extras - Additional context data
 * @param {number} timeout - Max time to wait in milliseconds (default: 2000)
 * @returns {Promise} Promise that resolves when logging is complete or times out
 */
const logErrorAsync = async (message, extras = {}, timeout = 2000) => {
  if (['int', 'prod', 'staging'].includes(env.name)) {
    return new Promise(resolve => {
      Sentry.withScope(scope => {
        Object.keys(extras).forEach(key => {
          scope.setExtra(key, extras[key]);
        });
        Sentry.captureException(Error(message));

        // Ensure the error is sent before resolving
        Sentry.flush(timeout).then(resolve).catch(resolve);
      });
    });
  }
  return Promise.resolve();
};

export default logError;
export { logErrorAsync };
